﻿import React, {ComponentPropsWithoutRef} from 'react';
import {styled} from "@mui/material/styles";
import {Theme} from "@mui/material";

type SearchFormContainerStyleProps = {
  isFixed?: boolean;
}

const Root = styled('form', {
  shouldForwardProp: (propName: PropertyKey) => propName !== 'isFixed'
})(({theme, isFixed = true}: { theme: Theme } & SearchFormContainerStyleProps) => ({
  width: isFixed ? '48em' : '100%', // mirrors leftContainer width, unless overridden
  boxShadow: '0em 0.14em 0.07em -0.07em rgba(0, 0, 0, 0.2), 0em 0.07em 0.07em rgba(0, 0, 0, 0.14), 0em 0.14em 0.21em rgba(0, 0, 0, 0.12)',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.background.default,
  [theme.breakpoints.down('lg')]: {
    width: "100%", // mirrors leftContainerWidth
  },
  zIndex: '1', // make sure it displays over images
}));

type SearchFormContainerProps = ComponentPropsWithoutRef<'form'> & SearchFormContainerStyleProps

const SearchFormContainer = (props: SearchFormContainerProps) => {
  return <Root {...props} />
}

export {SearchFormContainer};
